import { getAssetsURL } from '../../utilities/common/path';

//TODO: migrate once we have common path management file
const AssetURLs = {
  IndustryStandardFAQ: getAssetsURL(
    'uploads/Nov25_Intellect_Industry_Standards_FAQs.pdf',
  ),
};

export default AssetURLs;
